<template>
  <div
    class="banner d-flex flex-justify-center flex-align-center"
    :class="{ banner_visible: condition }"
    :style="{ backgroundColor: bgColor }"
  >
    <h2 v-if="condition" class="banner__message p-t-10 p-b-10">
      {{ message }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "AppBanner",
  props: {
    message: String,
    condition: Boolean,
    bgColor: {
      type: String,
      default: "#C53A40"
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  position: fixed;
  top: $headerDesktopHeight;
  left: 0px;
  width: 100%;
  height: 0;
  z-index: 2;
  transition: height 0.3s linear;

  @include respond-to-mobile {
    top: $headerMobileHeight;
  }

  &_visible {
    height: 50px;
  }

  &__message {
    text-transform: uppercase;
    color: $primary-color;
    cursor: default;
  }
}
</style>
